// extracted by mini-css-extract-plugin
export var container = "StockTakeSheets-module--container--cl-2c";
export var content = "StockTakeSheets-module--content--nvOnP";
export var noOrders = "StockTakeSheets-module--noOrders--U63IM";
export var subHeader = "StockTakeSheets-module--subHeader--R9VPr";